







import { Component, Vue, Inject } from "vue-property-decorator";
import iView from "iview";
import AbpBase from "@/lib/abpbase";
import ChangePassword from "../../components/change-password.vue";

@Component({
  components: { "change-password": ChangePassword }
})
export default class LoginChangePassword extends AbpBase {}
